import type { ReactNode } from 'react';

import styles from './MultiPartQuestion.module.css';

interface MultiPartQuestionProps {
  children: ReactNode;
}

export function MultiPartQuestion({ children }: MultiPartQuestionProps) {
  return <div className={styles.parts}>{children}</div>;
}

